module.exports = __webpack_public_path__ + "img/remark.4bce94d1.png";